import React, { useState } from "react";
import ImgLogo from "../../assets/images/full-logo-lightmode-svg.svg";
import SmallImgLogo from "../../assets/images/logo-lightmode-svg.svg";
import googlePlay from "../../assets/images/google-play-badge-logo.svg";
import { Link, useLocation } from "react-router-dom";
import "./navbar.css";
import {
  IconDotsCircleHorizontal,
  IconHome,
  IconHomeFilled,
  IconInfoCircle,
  IconInfoCircleFilled,
  IconLogin2,
  IconMail,
  IconMailFilled,
} from "@tabler/icons-react";

const Navbar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    {
      name: "Home",
      path: "/",
      activeIcon: <IconHomeFilled color="#4e1c4e" />,
      inactiveIcon: <IconHome stroke={1.5} />,
    },
    {
      name: "About Us",
      path: "/about",
      activeIcon: <IconInfoCircleFilled color="#4e1c4e" />,
      inactiveIcon: <IconInfoCircle stroke={1.5} />,
    },
    {
      name: "Contact Us",
      path: "/about",
      activeIcon: <IconMailFilled color="#4e1c4e" />,
      inactiveIcon: <IconMail stroke={1.5} />,
    },
    {
      name: "More",
      path: "/about",
      activeIcon: <IconDotsCircleHorizontal color="#4e1c4e" />,
      inactiveIcon: <IconDotsCircleHorizontal stroke={1.5} />,
    },
    // { name: 'Login', path: "/login", activeIcon: <IconLogin color='#4e1c4e' />, inactiveIcon: <IconLogin2 stroke={1.5} /> },
  ];

  const toggleMobileNav = () => {
    setIsOpen(!isOpen);
  };

  return (
    // <nav className="bg-gray-50 p-4 drop-shadow-md">  ******* navbar with a shadow ********
    // {/* {window.innerWidth < 640 ? (
    //   <div className=""><img className='w-[50px]' src={SmallImgLogo} alt="tipserve-logo" /></div>
    // ) : ( */}
    // {/* )} */}
    <>
      <nav className="p-4">
        <div className="mx-auto flex justify-between items-center">
          <Link to="/" className="cursor-pointer">
            <img
              className="w-[50px] sm:w-3/4"
              src={window.innerWidth < 640 ? SmallImgLogo : ImgLogo}
              alt="tipserve-logo"
            />
          </Link>
          <ul className="sm:flex sm:space-x-4 hidden">
            {navLinks.map((link) => (
              <li key={link.name}>
                <Link
                  to={link.path}
                  className={` hover:text-[#e9b22c] transition duration-200 ${
                    location.pathname === link.path ? "nav-link" : ""
                  }`}
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
          <ul className="sm:flex sm:space-x-4 sm:items-center hidden">
            {/* <li>
              <Link>Login</Link>
            </li> */}
              <li>
              <a href="https://play.google.com/store/apps/details?id=com.waiworld.tipserve&pcampaignid=web_share"> <img src={googlePlay} alt="google play" className="w-40" /> </a>
            </li>
            {/* <li>
              <Link className="py-1.5 px-2 rounded-lg bg-[#4e1c4e] text-white flex items-center">
                Get Started
              </Link>
            </li> */}
          </ul>

          {/* this is the hamburger/close icon to toggle on/off the canvas when in mobile view */}
          <div className="md:hidden">
            <button onClick={toggleMobileNav}>
              {!isOpen ? (
                <svg
                  className="w-7 h-7"
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  viewBox="0 0 50 50"
                >
                  <path d="M 5 8 A 2.0002 2.0002 0 1 0 5 12 L 45 12 A 2.0002 2.0002 0 1 0 45 8 L 5 8 z M 5 23 A 2.0002 2.0002 0 1 0 5 27 L 45 27 A 2.0002 2.0002 0 1 0 45 23 L 5 23 z M 5 38 A 2.0002 2.0002 0 1 0 5 42 L 45 42 A 2.0002 2.0002 0 1 0 45 38 L 5 38 z"></path>
                </svg>
              ) : (
                <svg
                  className="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
      </nav>

      {/* this is code for an off-canvas drawer in the mobile view*/}
      <div
        className={`flex flex-col p-4 fixed inset-y-0 left-0 max-w-xs w-3/4 bg-gray-50 z-50 overflow-y-auto transition duration-300 ease-in-out transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } md:hidden`}
      >
        <div>
          <div>
            <img className="w-[200px]" src={ImgLogo} alt="tipserve-logo" />
          </div>
          <ul className="mt-10">
            <h1 className="text-lg text-[#e9b22c] ps-1">Main Menu</h1>
            {navLinks.map((link) => (
              <li className="my-3" key={link.name}>
                <Link
                  to={link.path}
                  onClick={toggleMobileNav}
                  className={`flex gap-2 hover:text-[#e9b22c] transition duration-200 ${
                    location.pathname === link.path ? "nav-link" : ""
                  }`}
                >
                  {location.pathname === link.path
                    ? link.activeIcon
                    : link.inactiveIcon}
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <hr class="mt-6 mb-5 border-gray-400 sm:mx-auto" />
        <h1 className="text-lg text-[#e9b22c] ps-1">Account</h1>
        <ul>
          {/* <li className="my-5">
            <Link className="flex gap-2" onClick={toggleMobileNav}>
              <IconLogin2 color="#4e1c4e" />
              Login
            </Link>
          </li> */}
          {/* <li className="my-3">
            <Link
              className="py-1.5 px-2 rounded-lg bg-[#4e1c4e] text-white"
              onClick={toggleMobileNav}
            >
              Get Started
            </Link>
          </li> */}
          <li>
          <li>
              <a href="https://play.google.com/store/apps/details?id=com.waiworld.tipserve&pcampaignid=web_share"> <img src={googlePlay} alt="google play" className="w-40" /> </a>
            </li>
          </li>
        </ul>
      </div>

      {/* this is code for the dark overlay that can be clicked */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50 z-40 md:hidden"
          onClick={toggleMobileNav}
        ></div>
      )}
    </>
  );
};

export default Navbar;
